export const enum PaymentType {
  OfflinePayment = 1,
  OnlinePayment = 4,
}
